import { displayLatLonInCompassFormat } from '@deckee/utilities';
import React from 'react';
import { anchorWithX } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Unsafe anchorage',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'unsafe-anchorage',
  icon: {
    baseShape: anchorWithX,
    iconColor: '#fff',
    markerColor: '#E28D18',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'safety',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType: 'unsafeAnchorageMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Unsafe anchorage',
      itemTitleFunction: (item) =>
        (item &&
          item.geoJson &&
          item.geoJson.properties &&
          (item.geoJson.properties.title || item.geoJson.properties.bar)) ||
        'Unsafe anchorage',
    },
    creationOptions: {
      menuText: 'Unsafe anchorage',
      newTitle: 'Unsafe anchorage',
      titlePlaceholder: 'Name of unsafe anchorage',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker is used to indicate an unsafe anchorage. Include
          information such as factors to be aware of, potential concerns, or any
          caution to be advised.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [
        { label: 'Not permitted', isACtive: false },
        { label: 'Extremely poor holding', isACtive: false },
        { label: 'Dangerous tidal effects', isACtive: false },
        { label: 'Too shallow', isACtive: false },
        { label: 'Causeway', isACtive: false },
        { label: 'Mooring field', isACtive: false },
        { label: 'Underwater Obstruction', isACtive: false },
      ],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: false,
    title: 'Unsafe anchorage',
    description:
      marker && marker.geoJson && marker.geoJson.properties
        ? marker.geoJson.properties.bar
        : displayLatLonInCompassFormat(marker.latLon),
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
